import { useState } from 'react';
import { useAttendanceHistory } from '../../hooks/useAttendance';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { formatDuration } from '../../lib/utils';

function getDateStr(daysAgo: number): string {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().split('T')[0];
}

export function AttendanceHistoryPanel({
  userId,
  userName,
  onClose,
}: {
  userId: string;
  userName: string;
  onClose: () => void;
}) {
  const [dateRange, setDateRange] = useState({
    startDate: getDateStr(6),
    endDate: getDateStr(0),
  });

  const { data, isLoading } = useAttendanceHistory({ userId, ...dateRange });

  return (
    <div className="p-4 border rounded-md bg-gray-50 space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="font-medium text-sm">Attendance — {userName}</h4>
        <Button size="sm" variant="ghost" onClick={onClose}>
          Close
        </Button>
      </div>
      <div className="flex items-center gap-3">
        <Input
          type="date"
          value={dateRange.startDate}
          onChange={(e) => setDateRange((prev) => ({ ...prev, startDate: e.target.value }))}
          className="w-auto"
        />
        <span className="text-gray-500 text-sm">to</span>
        <Input
          type="date"
          value={dateRange.endDate}
          onChange={(e) => setDateRange((prev) => ({ ...prev, endDate: e.target.value }))}
          className="w-auto"
        />
      </div>
      {isLoading ? (
        <p className="text-sm text-gray-500">Loading...</p>
      ) : !data?.dailyTotals?.length ? (
        <p className="text-sm text-gray-500">No attendance recorded in this range</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm bg-white rounded-md">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 px-3">Day</th>
                <th className="text-left py-2 px-3">Work time</th>
                <th className="text-left py-2 px-3">Break time</th>
              </tr>
            </thead>
            <tbody>
              {data.dailyTotals.map((row: any) => (
                <tr key={row.day} className="border-b last:border-0">
                  <td className="py-2 px-3">{row.day}</td>
                  <td className="py-2 px-3">{formatDuration(row.workSeconds)}</td>
                  <td className="py-2 px-3 text-gray-500">{formatDuration(row.breakSeconds)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
